module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3X2BA"))).then(() => parcelRequire('1iHdE'));